import { render } from "./PdfView.vue?vue&type=template&id=9fea7a66&scoped=true"
import script from "./PdfView.vue?vue&type=script&lang=js"
export * from "./PdfView.vue?vue&type=script&lang=js"

import "./PdfView.vue?vue&type=style&index=0&id=9fea7a66&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fea7a66"]])

export default __exports__